<script>
    import Title from "../components/Title.svelte";
    import Background from "../components/Background.svelte";
    import SmallTitle from "../components/SmallTitle.svelte";
    import QrCode from "../components/QrCode.svelte";
</script>

<section id="video-channel">
    <Background>
        <img class="bg" src="images/index/video-channel-bg.svg">
    </Background>
    <Title title="『考研红宝书』讲解视频" hint="重磅推出词汇讲解视频 加深理解 加强记忆" />
    <div class="content">
        <div class="video-channel-block">
            <div class="video-channel-subtitle-block">
                <SmallTitle title="「哔哩哔哩视频」" hint="红宝书入驻B站 一起上岸发弹幕" icon="images/index/bilibili@1x.svg" />
            </div>
            <div class="phone-screen">
                <img src="images/index/哔哩哔哩视频.png"/>
            </div>
            <div class="qr-block">
                <QrCode qrImage="images/index/B站二维码.jpg" hint="扫码关注B站账号" moreHint="『考研英语红宝书』" />
            </div>
        </div>
        <div class="video-channel-block">
            <div class="video-channel-subtitle-block">
                <SmallTitle title="「微信视频号」" hint="视频学习资源 一键分享微信好友" icon="images/index/微信@1x.svg" />
            </div>
            <div class="phone-screen">
                <img src="images/index/微信视频号.png"/>
            </div>

            <div class="qr-block">
                <QrCode qrImage="images/index/微信视频号二维码.jpg" hint="扫码关注微信视频号" moreHint="『考研红宝书』" />
            </div>
        </div>
    </div>
</section>

<style>
    #video-channel {
        margin-top: 128px;
        margin-bottom: 84px;
    }

    .bg {
        position: absolute;
        top: 184px;
        width: 375px;
    }

    .content {
        margin-top: 32px;
        display: grid;
        align-items: center;
        justify-content: center;
        grid-template-columns: repeat(auto-fit, 160px);
    }

    .phone-screen img {
        margin-top: 20px;
        width: 156px;
    }

    .qr-block {
        margin-top: 18px;
    }
</style>
